import { render } from "./PagePrivacyPolicy.vue?vue&type=template&id=9a79de3e"
const script = {}

import exportComponent from "/tmp/build_c77b6d3d/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__